<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="font-style" #tooltip="matTooltip" matTooltip="Clamp Manufacturer" [matTooltipPosition]="tooltip_position">
        <!-- Clamp Manufacturer -->
        {{ 'CLAMP_PAGE.LABELS.CALC_INPUT.CLAMP_MANUFACTURER' | transloco }}
    </mat-label>

    <mat-select
        formControlName="clampManufacturer"
        name="clampManufacturer"
        class="input-select"
        [class.spinner]="loading"
        [class.select-disable]="enable"
        (selectionChange)="selectClampManufacturer($event)"
    >
        <mat-option class="option-list" *ngFor="let x of optionList" [value]="x.manufacturerId">{{ x.name }}</mat-option>
    </mat-select>
</div>
